function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
const SvgAura = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "aura-logo",
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  "data-animate": props.isAnimate || false,
  "data-interactive": props.animateOnInteraction || false
}, props), /*#__PURE__*/React.createElement("g", {
  className: "aura-logo__star"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.14493 0.417254C7.57924 -0.139085 8.42076 -0.139085 8.85507 0.417254L11.7223 4.09014C11.7769 4.1601 11.8399 4.22309 11.9099 4.2777L15.5827 7.14493C16.1391 7.57924 16.1391 8.42076 15.5827 8.85507L11.9099 11.7223C11.8399 11.7769 11.7769 11.8399 11.7223 11.9099L8.85507 15.5827C8.42076 16.1391 7.57924 16.1391 7.14493 15.5827L4.2777 11.9099C4.22309 11.8399 4.1601 11.7769 4.09014 11.7223L0.417254 8.85507C-0.139085 8.42076 -0.139085 7.57924 0.417254 7.14493L4.09014 4.2777C4.1601 4.22309 4.22309 4.1601 4.2777 4.09014L7.14493 0.417254Z",
  fill: "url(#paint0_linear_1035_13349)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.14493 0.417254C7.57924 -0.139085 8.42076 -0.139085 8.85507 0.417254L11.7223 4.09014C11.7769 4.1601 11.8399 4.22309 11.9099 4.2777L15.5827 7.14493C16.1391 7.57924 16.1391 8.42076 15.5827 8.85507L11.9099 11.7223C11.8399 11.7769 11.7769 11.8399 11.7223 11.9099L8.85507 15.5827C8.42076 16.1391 7.57924 16.1391 7.14493 15.5827L4.2777 11.9099C4.22309 11.8399 4.1601 11.7769 4.09014 11.7223L0.417254 8.85507C-0.139085 8.42076 -0.139085 7.57924 0.417254 7.14493L4.09014 4.2777C4.1601 4.22309 4.22309 4.1601 4.2777 4.09014L7.14493 0.417254Z",
  fill: "url(#paint1_radial_1035_13349)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.14493 0.417254C7.57924 -0.139085 8.42076 -0.139085 8.85507 0.417254L11.7223 4.09014C11.7769 4.1601 11.8399 4.22309 11.9099 4.2777L15.5827 7.14493C16.1391 7.57924 16.1391 8.42076 15.5827 8.85507L11.9099 11.7223C11.8399 11.7769 11.7769 11.8399 11.7223 11.9099L8.85507 15.5827C8.42076 16.1391 7.57924 16.1391 7.14493 15.5827L4.2777 11.9099C4.22309 11.8399 4.1601 11.7769 4.09014 11.7223L0.417254 8.85507C-0.139085 8.42076 -0.139085 7.57924 0.417254 7.14493L4.09014 4.2777C4.1601 4.22309 4.22309 4.1601 4.2777 4.09014L7.14493 0.417254Z",
  fill: "url(#paint2_radial_1035_13349)",
  fillOpacity: 0.3
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.14493 0.417254C7.57924 -0.139085 8.42076 -0.139085 8.85507 0.417254L11.7223 4.09014C11.7769 4.1601 11.8399 4.22309 11.9099 4.2777L15.5827 7.14493C16.1391 7.57924 16.1391 8.42076 15.5827 8.85507L11.9099 11.7223C11.8399 11.7769 11.7769 11.8399 11.7223 11.9099L8.85507 15.5827C8.42076 16.1391 7.57924 16.1391 7.14493 15.5827L4.2777 11.9099C4.22309 11.8399 4.1601 11.7769 4.09014 11.7223L0.417254 8.85507C-0.139085 8.42076 -0.139085 7.57924 0.417254 7.14493L4.09014 4.2777C4.1601 4.22309 4.22309 4.1601 4.2777 4.09014L7.14493 0.417254Z",
  fill: "url(#paint3_radial_1035_13349)",
  fillOpacity: 0.6
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.14493 0.417254C7.57924 -0.139085 8.42076 -0.139085 8.85507 0.417254L11.7223 4.09014C11.7769 4.1601 11.8399 4.22309 11.9099 4.2777L15.5827 7.14493C16.1391 7.57924 16.1391 8.42076 15.5827 8.85507L11.9099 11.7223C11.8399 11.7769 11.7769 11.8399 11.7223 11.9099L8.85507 15.5827C8.42076 16.1391 7.57924 16.1391 7.14493 15.5827L4.2777 11.9099C4.22309 11.8399 4.1601 11.7769 4.09014 11.7223L0.417254 8.85507C-0.139085 8.42076 -0.139085 7.57924 0.417254 7.14493L4.09014 4.2777C4.1601 4.22309 4.22309 4.1601 4.2777 4.09014L7.14493 0.417254Z",
  fill: "url(#paint4_radial_1035_13349)"
})), /*#__PURE__*/React.createElement("g", {
  className: "aura-logo__flower"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.77233 4.80112C6.75081 3.06629 9.24919 3.06629 10.2277 4.80112C10.4568 5.20735 10.7926 5.5432 11.1989 5.77233C12.9337 6.75081 12.9337 9.24919 11.1989 10.2277C10.7926 10.4568 10.4568 10.7926 10.2277 11.1989C9.24919 12.9337 6.75081 12.9337 5.77233 11.1989C5.5432 10.7926 5.20735 10.4568 4.80112 10.2277C3.06629 9.24919 3.06629 6.75081 4.80112 5.77233C5.20735 5.5432 5.5432 5.20735 5.77233 4.80112Z",
  fill: "url(#paint5_linear_1035_13349)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M8.01799 6.28304C8.64278 5.60584 9.75202 6.24626 9.47794 7.12594C9.37868 7.4445 9.47173 7.79174 9.71696 8.01799C10.3942 8.64278 9.75374 9.75202 8.87406 9.47794C8.5555 9.37868 8.20826 9.47173 7.98201 9.71696C7.35722 10.3942 6.24798 9.75374 6.52206 8.87406C6.62132 8.5555 6.52827 8.20826 6.28304 7.98201C5.60584 7.35722 6.24626 6.24798 7.12594 6.52206C7.4445 6.62132 7.79174 6.52827 8.01799 6.28304Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1035_13349",
  x1: 8,
  y1: 4,
  x2: 3,
  y2: 4.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6358DE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4F46B2"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_1035_13349",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(0.446038 6.45346) rotate(-28.8122) scale(15.7463 8.12778)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6358DE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6358DE",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial_1035_13349",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(-0.237782 7.74512) rotate(-41.7295) scale(11.3009 3.05595)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.230133,
  stopColor: "#DBD9F7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6358DE",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial_1035_13349",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(12.3459 10.5512) rotate(5.99343) scale(9.18835 13.7751)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.300528,
  stopColor: "#78BEFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6358DE",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint4_radial_1035_13349",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(1.47462 13.311) rotate(-30.5101) scale(8.41893 6.49565)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#453E9B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.791256,
  stopColor: "#4F46B2",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_1035_13349",
  x1: 8,
  y1: 5.64634,
  x2: 12,
  y2: 11.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B3AEEF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BCDFFF"
}))));
export default SvgAura;